import { useMemo } from "react";
import { StarEmblem } from "@/components/TarotSpreadCard";

export const DeckFan = ({ shuffling, caption }) => {
  const angles = useMemo(() => {
    const n = 13;
    return Array.from({ length: n }, (_, i) => -54 + (108 / (n - 1)) * i);
  }, []);

  return (
    <div className="relative h-[290px] overflow-hidden select-none" data-testid="deck-fan">
      {angles.map((a, i) => (
        <div
          key={i}
          className={`fan-card ${shuffling ? "fan-shuffling" : ""}`}
          style={{ "--a": `${a}deg`, zIndex: i, animationDelay: `${i * 45}ms` }}
        >
          <div className="fan-card-inner">
            <StarEmblem />
          </div>
        </div>
      ))}
      {caption && (
        <p
          className="absolute bottom-5 left-1/2 -translate-x-1/2 z-30 font-heading italic text-sm text-[#cfc6e8] tracking-wide whitespace-nowrap"
          data-testid="fan-caption"
        >
          {caption}
        </p>
      )}
    </div>
  );
};
